import * as React from "react";
const RestoredArchivesCell = ({ archive }) => /* @__PURE__ */ React.createElement("span", null, archive.restore_history == null ? 0 : archive.restore_history.length);
export default RestoredArchivesCell;
